import config from "@/config/config";
import type { AuthAdapter } from "@/core/auth/adapter";
import { TanstackDevtools } from "@tanstack/react-devtools";
import { Outlet, createRootRouteWithContext } from "@tanstack/react-router";
import { TanStackRouterDevtoolsPanel } from "@tanstack/react-router-devtools";

export const Route = createRootRouteWithContext<{
	authAdapter: AuthAdapter;
}>()({
	component: () => (
		<>
			<Outlet />
			{config.ENABLE_TANSTACK_DEVTOOLS && (
				<TanstackDevtools
					config={{ position: "bottom-right" }}
					plugins={[
						{
							name: "Tanstack Router",
							render: <TanStackRouterDevtoolsPanel />,
						},
					]}
				/>
			)}
		</>
	),
});
